module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-400.woff?46a7d48240d428c9dc3d4ff579199312";